<template>
  <vjs-modal v-bind="$options.propsData"
             :title="title"
             icon="la la-calendar"
             @opened="loadEntries">
    <template slot="body-content">
      <div class="edit-scheduled-entries-content" @submit.stop.prevent>
        <div class="form-group">
          <label for="editables">Values that need changing:</label>
          <multiselect
            id="feed-select"
            v-model="editable_values"
            label="name"
            :hide-selected="true"
            track-by="code"
            :options="editables"
            :option-height="150"
            placeholder="Select entries you want to edit..."
            :taggable="true"
            :multiple="true" />
          <span class="form-text text-muted">
            Only entries selected will be changed in scheduled recording.<br>
          </span>
        </div>
        <div v-show="showEntry('Name')" class="form-group kt-form__group no-gutters">
          <label for="showname">Event name:</label>
          <input id="showname" v-model="showname"
                 type="text"
                 class="form-control" placeholder="Change name...">
          <span v-show="multi" class="form-text text-muted">
            Last name found is filled. Please make sure it is the name you want for multiple items.<br>
          </span>
        </div>
        <div v-show="showEntry('Description')" class="form-group">
          <label for="description">Description:</label>
          <textarea id="description" v-model="description"
                    class="form-control"
                    rows="3" placeholder="Change description..." />
          <span v-show="multi" class="form-text text-muted">
            Last description found is filled. Please make sure it is the description your for multiple items.<br>
          </span>
        </div>
        <div v-show="showEntry('Tags')" class="form-group">
          <label for="tags">Event tags:</label>
          <multiselect
            id="feed-select"
            v-model="ms_tag_values"
            :options="auto_complete_tags"
            :hide-selected="true"
            placeholder="Search or add new tags..."
            :multiple="true"
            :taggable="true"
            track-by="uuid"
            label="name"
            @tag="addNewTag" />
          <span v-show="multi" class="form-text text-muted">
            Tags can only be replaced. Existing tags will be overriden. Multiple selected entries tags are merged.<br>
          </span>
        </div>
        <div v-show="showEntry('Date & Time')">
          <div class="form-group">
            <label for="event-start">Event start:</label>
            <datetime id="event-start" v-model="start_date_time"
                      :auto="true" :value-zone="timezone"
                      :zone="timezone"
                      :min-datetime="min_date_time_start"
                      input-class="form-control"
                      type="datetime" :format="date_format"
                      @close="startDateTimeClose" />
            <span class="form-text text-muted">
              Broadcast start. New date and time in the future needs to be set. The value prefilled is not current value.
            </span>
          </div>
          <div class="form-group">
            <label for="event-stop">Event end:</label>
            <datetime id="event-stop"
                      v-model="stop_date_time"
                      :auto="true"
                      :value-zone="timezone"
                      :zone="timezone"
                      :min-datetime="min_date_time_stop"
                      :max-datetime="max_date_time_stop"
                      input-class="form-control"
                      type="datetime" :format="date_format"
                      @close="stopDateTimeClose" />
            <span class="form-text text-muted">
              Broadcast end. New date and time in the future needs to be set. The value prefilled is not current value.
            </span>
          </div>
          <div v-if="(frequency_selected === 'daily' || frequency_selected === 'weekly') && ttype === 'cron'" class="form-group">
            <label for="event-recur-begin">Recur from:</label>
            <datetime id="event-recur-begin" v-model="recur_from"
                      :auto="true" :value-zone="timezone"
                      :zone="timezone"
                      :min-datetime="min_begin_from_date"
                      input-class="form-control"
                      type="datetime" :format="date_format"
                      @close="beginFromDateTimeClose" />

            <span class="form-text text-muted">
              A date and time from which the recording will take affect. When editing previous values will be lost.
            </span>
          </div>
          <div v-if="(frequency_selected === 'daily' || frequency_selected === 'weekly') && ttype === 'cron'" class="form-group">
            <label for="event-recur-begin">Recur until:</label>
            <datetime id="event-recur-end"
                      v-model="recur_until"
                      :auto="true"
                      :value-zone="timezone"
                      :zone="timezone"
                      :min-datetime="min_end_before_date"
                      :max-datetime="max_end_before_date"
                      input-class="form-control"
                      type="datetime"
                      :format="date_format" />
            <span class="form-text text-muted">
              A date and time until which the recording will no longer continue.
            </span>
          </div>
        </div>
        <div v-show="showEntry('Publishing')">
          <div v-if="frequency_selected === 'once' || ttype === 'once'" class="form-group">
            <label for="event-publish-start">Publish start:</label>
            <datetime id="event-publish-start" v-model="publish_start_date_time"
                      :auto="true" :value-zone="timezone"
                      :zone="timezone"
                      :min-datetime="min_publish_date_time_start" input-class="form-control"
                      type="datetime" :format="date_format"
                      @close="publishStartDateTimeClose" />
          </div>
          <div v-if="frequency_selected === 'once' || ttype === 'once'" class="form-group">
            <label for="event-publish-stop">Publish stop:</label>
            <datetime id="event-publish-stop"
                      v-model="publish_stop_date_time"
                      :auto="true"
                      :value-zone="timezone"
                      :zone="timezone"
                      :min-datetime="min_publish_date_time_stop"
                      input-class="form-control"
                      type="datetime" :format="date_format" />
          </div>
          <div v-if="frequency_selected === 'cron' || ttype === 'cron'" class="form-group">
            <duration-picker v-model="publishduration" :seconds="true" label="Publish duration:" />
          </div>
          <div v-if="frequency_selected === 'cron' || ttype === 'cron'" class="form-group">
            <duration-picker v-model="publishdelay" label="Publish delay:" />
          </div>
        </div>
        <div v-show="showEntry('Frequency')">
          <div class="form-group">
            <multiselect v-model="frequency_selected" :options="['once', 'daily', 'weekly']" :allow-empty="false" />
          </div>
          <div class="form-group">
            <div v-if="frequency_selected === 'weekly'">
              <ul class="clean-list days-list">
                <li v-for="day in ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']" :key="day" class="">
                  <ss-checkbox :id="`check-${day}`" v-model="days_selected[day.toUpperCase()]">
                    {{ day }}
                  </ss-checkbox>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-show="showEntry('Artwork')" class="form-group">
          <div class="col-12 col-md-6 col-lg-4">
            <display-with-selection-modal :preselected-artwork="artwork_to_display" @selected="(ev) => (selected_artwork = ev.selected_artwork)" />
          </div>
        </div>
        <div v-show="showEntry('Stream')" class="form-group">
          <label for="event-stream">Stream:</label>
          <multiselect id="event-stream" v-model="streamname"
                       :allow-empty="false"
                       deselect-label="An event must have a stream"
                       placeholder="Select a stream..."
                       :options="streams"
                       track-by="name" label="name" />
        </div>

        <!-- Show information about next trigger if user is not changing dates (because it won't auto update on change and it
             is recurring event to help avoid missed due to recur_from and recur_until.
             Also show a warning if multiple are being edited.
         -->
        <div v-if="ttype === 'cron' && ! showEntry('Date & Time')">
          <div v-if="!multi">
            <div><span>Next recording at <b>{{ start_time }}</b> {{ frequency_selected }} {{ weekly_days }} until: <b>{{ recur_until_local_date_only }}</b></span></div>
            <div><span v-if="recur_from_warning" style="color:red">Will only start from: {{ recur_from_local_date_only }}</span></div>
            <div><span v-if="recur_until_warning" style="color:red">Will conclude at {{ recur_until_local_date_only }}</span></div>
          </div>
          <div v-else>
            <span style="color: red">Warning: Multiple recurring events are being edited!</span>
          </div>
        </div>

        <quick-alert-modal v-bind="quick_alert" scope="edit-entries" />
      </div>
    </template>
    <template slot="body-controls">
      <div style="margin: auto; text-align: center;">
        <b-button variant="ss-standout" @click="() => close(true)">
          Confirm
        </b-button>
        <b-button variant="ss" @click="() => close(false)">
          Cancel
        </b-button>
        <span>Timezone: </span> <span style="font-weight: bold"> {{ timezone }} </span>
      </div>
    </template>
  </vjs-modal>
</template>

<script>

import { Datetime } from "vue-datetime";
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';
import VjsModal from 'VueComponents/VJSModals/VjsModal';
import VjsModalMixin from 'VueComponents/VJSModals/VjsModalMixin';
import { nullish } from 'Lib/type-sanity';
import DisplayWithSelectionModal from "VuePartials/Artwork/DisplayWithSelectionModal";
import DurationPicker from 'VueComponents/DurationPicker';

const duration_obj_to_string = (dur_obj) => {
  const o = moment.duration(Object.entries(dur_obj).reduce((acc, [k, v]) => {
    if (k === `days`) acc += (1000 * 60 * 60 * 24) * v;
    else if (k === `hours`) acc += (1000 * 60 * 60) * v;
    else if (k === `minutes`) acc += (1000 * 60) * v;
    else if (k === `seconds`) acc += 1000 * v;
    return acc;
  }, 0)).asSeconds();
  return o;
};

export default {
  name: `edit-scheduled-entries-modal`,
  components: {
    DisplayWithSelectionModal,
    VjsModal,
    Datetime,
    DurationPicker,
  },
  mixins: [TaggableModelMixin, VjsModalMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: `Edit Scheduled Recordings`,
    },
    entries: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    // Not working (vue returns old value):(
    refreshCalendar: {
      type: Function,
      default: () => 1,
    },
    // Reference to full calendar
    fullCalendar: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    timezone: window.user.timezone ?? 'UTC',
    editables: [
      { name: 'Name', code: 'showname' },
      { name: 'Description', code: 'description' },
      { name: 'Tags', code: 'tags' },
      { name: 'Artwork', code: 'image' },
      { name: 'Date & Time', code: 'date_and_time' },
      { name: 'Frequency', code: 'frequency' },
      { name: 'Publishing', code: 'publishing' },
      { name: 'Stream', code: 'streamname' },
    ],
    entries_data: [],
    editable_values: [],
    editable: "",
    tags: [],
    tag: "",
    showname: null,
    description: null,
    selected_artwork: null,
    frequency_selected: 'once',
    weekly_days: null,
    duration: null,
    start_time: null,
    start_date_time: null,
    stop_date_time: null,
    days_selected: {
      MON: false,
      TUE: false,
      WED: false,
      THU: false,
      FRI: false,
      SAT: false,
      SUN: false,
    },
    image: null,
    multi: false,
    ttype: null,
    publish_start_date_time: null,
    publish_stop_date_time: null,
    publishduration: {
      seconds: window.preferences.scheduler_publishduration,
    },
    publishdelay: {},
    multipleFrequenciesSelected: false,
    streamname: null,
    recur_from: null,
    recur_until: null,
    recur_from_local: null,
    recur_from_local_date_only: null,
    recur_until_local: null,
    recur_until_local_date_only: null,
    recur_from_warning: false,
    recur_until_warning: false,
    startsat: null,
    endsat: null,
  }),

  asyncComputed: {
    streams: {
      async get() {
        try {
          const res_data = (await axios.get('/api/v1/streams')).data.data.streams;
          return this.fallback(res_data, []);
        } catch (err) {
          window.handleAxiosError(err);
          return [];
        }
      },
      default: [],
    },
  },

  computed: {
    artwork_to_display() {
      if (this.selected_artwork) {
        return this.selected_artwork;
      }
      return null;
    },
    date_format() {
      return 'dd-MM-yyyy HH:mm';
    },
    min_date_time_start() {
      return moment()
        .add(2, "minutes")
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
    // minimum stop is 1 min longer than start
    min_date_time_stop() {
      return moment(this.start_date_time)
        .add(3, 'minutes')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
    // maximum stop can be 24h
    max_date_time_stop() {
      return moment(this.start_date_time)
        .add(24, 'hours')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
    event_duration() {
      return moment.duration(moment(this.stop_date_time).diff(this.start_date_time)).asMinutes();
    },
    min_publish_date_time_start() {
      return moment(this.stop_date_time).toISOString();
    },
    // minimum publish stop is 1 min longer than publish start
    min_publish_date_time_stop() {
      return moment(this.publish_start_date_time)
        .add(1, 'minutes')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
    min_begin_from_date() {
      return moment(this.start_date_time)
        .subtract(5, 'hours')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
    min_end_before_date() {
      return moment(this.begin_from_date)
        .add(1, 'days')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
    max_end_before_date() {
      return moment(this.begin_from_date)
        .add(101, 'years')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
    },
  },
  watch: {
    frequency_selected(newValue) {
      // Automatically add Date & Time when it is selected to Once
      // One direction only. By changing from CRON to ONCE time will 99.99% of the time will be too early!
      if (newValue === 'once') {
        this.addEditable("Date & Time", "date_and_time");
      }
    },
  },
  beforeMount() {
    this.fetchTags();
  },
  mounted() {
    // Artwork selected from artwork modal
    EventBus.$on('new_artwork_selected', (payload) => {
      this.selected_artwork = payload;
    });
  },

  methods: {
    nullish,
    close(confirm) {
      this.close_data = {
        confirm,
      };

      if (this.showEntry('Name')) {
        this.close_data.showname = this.showname;
      }

      if (this.showEntry('Description')) {
        this.close_data.description = this.description;
      }

      if (this.showEntry('Tags')) {
        this.close_data.tags = this.ms_tag_values;
      }

      if (this.showEntry('Artwork')) {
        this.close_data.image = this.selected_artwork.path ?? this.image;
      }

      if (this.showEntry('Date & Time')) {
        this.close_data.broadcaststart = this.start_date_time;
        this.close_data.broadcastend = this.stop_date_time;

        if (this.ttype === 'cron') {
          this.close_data.startsat = moment(this.recur_from);
          this.close_data.endsat = moment(this.recur_until);
        }
      }

      if (this.showEntry('Frequency')) {
        // this.shownEntry("Date & Time") = true;
        this.close_data.freq = this.frequency_selected;

        const daysSelectedArray = Object.entries(this.days_selected);

        if (this.close_data.freq === 'weekly') {
          this.close_data.ttype = 'cron';

          // Checks array of arrays and makes a flat array of weeks that are selected
          this.close_data['weekly-day'] = daysSelectedArray.reduce((acc, [k, v]) => {
            if (v === true) acc.push(k.toUpperCase());
            return acc;
          }, []);

          // If all checkboxes are ticked, convert it as daily
          if (this.close_data['weekly-day'].length === 7) {
            this.close_data['weekly-day'] = null;
            this.close_data.freq = 'daily';
          }
        } else if (this.close_data.freq === 'daily') {
          this.close_data.freq = 'daily';
          this.close_data['weekly-day'] = null;
        } else if (this.close_data.freq === 'once') {
          // Convert cron to once
          this.close_data.ttype = 'once';
          this.close_data.freq = null;
        }
      }

      if (this.showEntry('Publishing')) {
        this.close_data.publishdelay = !this.nullish(this.publishdelay) ? duration_obj_to_string(this.publishdelay) : null;
        this.close_data.publishduration = (() => {
          if (!this.nullish(this.publishduration)) {
            if (typeof this.publishduration === 'number') {
              return this.publishduration;
            }
            return this.durationObjToUnit(this.publishduration);
          }
          return 0;
        })();

        this.close_data.publishstart = moment(this.publish_start_date_time).toISOString();
        this.close_data.publishstop = moment(this.publish_stop_date_time).toISOString();
      }

      if (this.showEntry('Stream')) {
        this.close_data.streamname = this.streamname.name;
      }

      this.close_data.timezone = this.timezone;

      if (this.multi) {
        this.complete();
        this.clearModalForm();
      } else {
        if (this.ttype !== 'cron') {
          // note: runat while cron trigger type will throw moment warning because it contains cron command!!!
          const isFutureDate = moment(this.entries_data[0].runat).isAfter(moment());
          if (isFutureDate) {
            this.complete();
            this.clearModalForm();
          } else {
            // Prevent editing when it is way too soon. 2 min should be enough (if not cron)
            if (moment(this.close_data.broadcaststart).isBefore(moment().add(2, "minutes")) && this.frequency_selected === 'once') {
              this.addEditable("Date & Time", "date_and_time");
              this.addEditable("Publishing", 'publishing');
              this.quickAlert({
                title: "Error",
                message: "Event start must be at least 2 minutes in the future!",
                variant: "error",
              }, "edit-entries");
            } else {
              this.complete();
              this.clearModalForm();
            }
          }
        } else {
          this.complete();
          this.clearModalForm();
        }
      }
    },

    async loadEntries() {
      this.editable_values = [];
      this.entries_data = this.entries;

      if (this.entries_data.length > 1) {
        this.multi = true;
      } else {
        this.multi = false;
      }

      const tags = [];
      _.forEach(this.entries_data, (entry) => {
        _.forEach(entry?.tags?.toString().split(','), (entryTag) => {
          tags.push(entryTag);
        });
      });

      this.setScheduledRecordingTags(_.uniq(tags));
      // Load the rest (takes last one)
      _.forEach(this.entries_data, (entry) => {
        this.description = entry.description;
        this.showname = entry.showname;
        // spoof image object
        this.image = entry?.image?.split('/')?.reverse()[0];
        if (this.image) {
          this.selected_artwork = { "name": this.image, "path": entry.image };
        }

        this.ttype = entry.ttype;

        if (this.ttype === 'cron') {
          const multiSelectFrequencies = [];
          if (_.uniq(multiSelectFrequencies).length > 1) {
            this.multipleFrequenciesSelected = true;
          }
          this.frequency_selected = entry?.cronExtraData?.freq;

          // Fill weekly checkboxes
          if (this.frequency_selected === 'weekly') {
            Object.keys(this.days_selected).forEach(k =>
              this.$set(this.days_selected, k, false));
            const rawDays =
              entry?.cronExtraData?.['weekly-day']
              ?? entry?.cronExtraData?.weekly_days
              ?? (entry?.cronExtraData?.weekly_days_string || '').split(',');
            rawDays.filter(Boolean).forEach((d) => {
              const key = d.trim().slice(0, 3).toUpperCase();
              if (key in this.days_selected) {
                this.$set(this.days_selected, key, true);
              }
            });
          }

          // Clear the dates, otherwise it will show the previous one on next modal show
          this.recur_from = null;
          this.recur_until = null;
          this.start_date_time = null;
          this.stop_date_time = null;

          // When is not multiselect, get the date and fill it in.
          if (!this.multi) {
            this.start_date_time = moment.tz(entry.cronExtraData.nextfiretime, entry.timezone).toISOString();
            this.stop_date_time = moment.tz(entry.cronExtraData.nextfiretime, entry.timezone).add(Number(entry.duration), 'seconds').toISOString();
            this.start_time = entry.cronExtraData.time_input;
            this.weekly_days = entry.cronExtraData.weekly_days_string;
            this.recur_from = moment.tz(entry.startsat, entry.timezone).toISOString();
            this.recur_until = moment.tz(entry.endsat, entry.timezone).toISOString();
            this.recur_from_local = moment(this.recur_from).local().format('YYYY-MM-DD HH:mm:ss');
            this.recur_from_local_date_only = moment(this.recur_from).local().format('YYYY-MM-DD');
            this.recur_until_local = moment(this.recur_until).local().format('YYYY-MM-DD HH:mm:ss');
            this.recur_until_local_date_only = moment(this.recur_until).local().format('YYYY-MM-DD');

            const currentDate = moment();
            const recurFromDate = moment(this.recur_from);
            const nextFireTime = moment(this.start_date_time);
            const recurUntilDate = moment(this.recur_until);

            // Warn user if while editing recurring will stop in 2 months
            if (recurUntilDate.diff(currentDate, 'months') <= 2) {
              this.recur_until_warning = true;
            } else {
              this.recur_until_warning = false;
            }

            if (recurFromDate.isAfter(nextFireTime)) {
              this.recur_from_warning = true;
            } else {
              this.recur_from_warning = false;
            }
          }
        }

        if (this.ttype !== 'cron') {
          // Prefil the dates and times so when it is in the future it will still be fine. Will not let the submission if in the past anyway.
          // Only do this if it is not CRON because runat will contain cron command which is not a valid moment format!
          this.start_date_time = moment.tz(entry.runat, entry.timezone).toISOString();
          this.stop_date_time = moment.tz(entry.runat, entry.timezone).add(Number(entry.duration), 'seconds').toISOString();
        }

        this.publishdelay = {
          seconds: entry?.publishdelay ?? window.preferences.scheduler_publishdelay,
        };

        this.publishduration = {
          seconds: entry.publishduration ?? window.preferences.scheduler_publishduration,
        };

        this.streamname = this.streams.find(stream => stream.name === entry.streamname);
      });
    },

    async setScheduledRecordingTags(tags) {
      this.ms_tag_values = [];
      _.forEach(tags, (tag) => {
        this.ms_tag_values.push(tag);
      });
    },

    showEntry(value) {
      if (this.editable_values.some(editable => editable.name === value)) {
        return true;
      }
      return false;
    },

    async beforeOpen() {
      this.clearModalForm();
    },

    clearModalForm() {
      this.entries_data = [];
      this.editable_values = [];
      this.ms_tag_values = [];
      this.description = null;
      this.showname = null;
      this.image = null;
      this.broadcaststart = null;
      this.broadcastend = null;
      this.duration = null;
      this.startsat = null;
      this.endsat = null;
      this.publishdelay = {};
      this.publishduration = {};
      this.streamname = null;
      this.days_selected = {
        MON: false,
        TUE: false,
        WED: false,
        THU: false,
        FRI: false,
        SAT: false,
        SUN: false,
      };
    },

    startDateTimeClose() { // Copy from ScheduledEventForm.vue
      const min = moment(this.start_date_time)
        .add(10, 'minutes')
        .set({
          seconds: 0,
          milliseconds: 0,
        })
        .toISOString();
      this.stop_date_time = min;
      if (moment(this.start_date_time).diff(this.recur_from) > 0) {
        this.recur_from = moment(min).subtract(5, 'hours').subtract(10, 'minutes').toISOString();
      }
      if (moment(this.recur_from).diff(this.recur_until) > 0) {
        this.recur_until = moment(min).add(2, 'years').subtract(5, 'hours').toISOString();
      }

      this.handlePublishingDateAdjustment();
    },

    handlePublishingDateAdjustment() {
      if (this.frequency_selected === 'once' || this.ttype === 'once') {
        this.publish_start_date_time = moment(this.stop_date_time).toISOString();
        this.publish_stop_date_time = moment(this.stop_date_time).add(7, 'days').toISOString();
      }
    },

    stopDateTimeClose() {
      this.handlePublishingDateAdjustment();
    },

    publishStartDateTimeClose() {
      if (moment(this.publish_start_date_time).diff(this.publish_stop_date_time) > 0) {
        this.publish_stop_date_time = moment(this.publish_start_date_time).add(7, 'days').toISOString();
      }
    },

    beginFromDateTimeClose() {
      if (moment(this.recur_from).diff(this.recur_until) > 0) {
        this.recur_until = moment(this.recur_from).add(2, 'years').toISOString();
      }
    },

    addEditable(name, code) {
      this.editable_values.push({
        name: name,
        code: code,
      });

      this.editable_values = _.uniqBy(this.editable_values, 'code');
    },

  },
};
</script>

<style lang="scss" scoped>
:deep(.multiselect__content-wrapper) {
  position: static;
  border-bottom: 1px solid #e8e8e8;
}
</style>
